import React from 'react';
import { 
    Show, TextField , TopToolbar, EditButton, useGetOne, CloneButton,
    DeleteButton, LinearProgress, useRedirect
} from 'react-admin';
import { makeStyles, Typography, Box, Button } from '@material-ui/core';
import ToolbarBackButton from '../components/ToolbarBackButton';
import MyTooltip from "../components/MuiTooltip";
import FilterNoneRoundedIcon from '@material-ui/icons/FilterNoneRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';
import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined';
import PermContactCalendarOutlinedIcon from '@mui/icons-material/PermContactCalendarOutlined';
import lightTheme from '../layout/themes';

import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';

const useStyles = makeStyles({
    AsideProviderAddress: lightTheme.AsideProviderAddress,
    PostViewTypography: lightTheme.PostViewTypography,
    Shop_Image: lightTheme.PointOfSaleStyle.View.Info_Card.Shop_Image,
    LogoBox: lightTheme.CompanyStyle.View.LogoBox,
    InfoBox: lightTheme.CompanyStyle.View.InfoBox,
    ContactBox: lightTheme.CompanyStyle.View.ContactBox,
    Aside: lightTheme.CompanyStyle.View.Aside,
    TimeLine: lightTheme.CompanyStyle.View.TimeLine,
    DirectionCard: lightTheme.CompanyStyle.View.DirectionCard,
    Contact: lightTheme.CompanyStyle.View.Contact,
    MapsButton: lightTheme.CompanyStyle.View.MapsButton
});

const StateName = ({ id }) => {
    const { data, loading, error } = useGetOne('state', id);
    if (loading) { return <LinearProgress /> }
    if (error) { return <p>ERROR</p>; }
    if (data) return (data.name);
};

const CountryName = ({ id }) => {
    const { data, loading, error } = useGetOne('country', id);
    if (loading) { return <LinearProgress /> }
    if (error) { return <p>ERROR</p>; }
    if (data) return (data.name);
};

const PointsView = ({ permissions, ...props }) => {
    const { data } = useGetOne('company', props.id);
    const DateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const classes = useStyles();
    const redirect = useRedirect();

    const Aside = () => {
        const classes = useStyles();
        return(
            <div>
                {data &&
                    <div>
                        <div className={classes.TimeLine}>
                            <Timeline>
                                <TimelineItem>
                                    <TimelineSeparator>
                                        <AccessTimeRoundedIcon style={{color: '#cacaca', padding: '10px'}}/>
                                        <TimelineConnector style={{width: '1px'}}/>
                                    </TimelineSeparator>
                                    <TimelineContent style={{marginBottom: '20px'}}>
                                        <span style={{fontSize: '1.1rem', color: '#000'}}>{new Date(data.createdate).toLocaleDateString("es-ES", DateOptions)}</span><br/>
                                        <span style={{color: '#196cdb'}}>{data.createdby}</span><br/>
                                        <span style={{color: 'rgb(102, 102, 102)'}}>Sociedad creada</span>
                                    </TimelineContent>
                                </TimelineItem>
                                {data.lastupdate &&
                                    <TimelineItem>
                                        <TimelineSeparator>
                                            <AccessTimeRoundedIcon style={{color: '#cacaca', padding: '10px'}}/>
                                        </TimelineSeparator>
                                        <TimelineContent>
                                            <span style={{fontSize: '1.1rem', color: '#000'}}>{new Date(data.lastupdate).toLocaleDateString("es-ES", DateOptions)}</span><br/>
                                            <span style={{color: '#196cdb'}}>{data.updatedby}</span><br/>
                                            <span style={{color: 'rgb(102, 102, 102)'}}>Sociedad actualizada</span>
                                        </TimelineContent>
                                    </TimelineItem>
                                }
                            </Timeline>
                        </div>
                    </div>
                }
            </div>
        )
    };

    const PointsViewActions = ({ basePath, resource }) => {
        return(
            <TopToolbar style={{paddingBottom: '2px', marginTop: '22px'}} id="GoogleStyleToolBar">
                <Box display="flex" style={{ width: '100%' }} justifyContent="flex-start">
                    <MyTooltip title={<div style={{fontSize: '12px'}}>Volver Atrás</div>} arrow>
                        <ToolbarBackButton style={{paddingLeft: '17px', paddingRight: '5px', marginRight: '10px'}} id="GoogleStyleBackButton"></ToolbarBackButton>
                    </MyTooltip>
                    {permissions === "Admin" &&
                        <Box display="flex" style={{ width: '100%', marginRight: '20px' }} justifyContent="flex-start">
                            <MyTooltip title={<div style={{fontSize: '12px'}}>Duplicar Sociedad</div>} arrow>
                                <CloneButton label="" icon={<FilterNoneRoundedIcon /> } basePath={basePath} record={data} resource={resource} id="GoogleStyleButton"/>
                            </MyTooltip>
                            <MyTooltip title={<div style={{fontSize: '12px'}}>Editar Sociedad</div>} arrow>
                                <EditButton label="" type="link" to={`/company/${props.id}/edit`} id="GoogleStyleButton"/>
                            </MyTooltip>
                            <MyTooltip title={<div style={{fontSize: '12px'}}>Eliminar Sociedad</div>} arrow>
                                <DeleteButton label="" redirect={`/company`} record={data} resource={resource} id="GoogleStyleDeleteButton"/>
                            </MyTooltip>
                        </Box>
                    }
                </Box>
            </TopToolbar>
        )
    };

    return (
        <Box>
            <Show {...props} actions={<PointsViewActions />} aside={<Aside />} style={{marginTop: '-20px'}} >
                <Box>
                    {data &&
                        <Box>
                            <Box style={{width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
                                <div className={classes.LogoBox} id="ShopLogo">
                                    <img src="../../static/images/Shops/TrendicoFaviconRounded.png" alt="Trendico" id="Trendico"></img>
                                </div>
                                <Box className={classes.InfoBox}>
                                    <TextField source="name" style={{fontSize: '1.5rem'}}/>
                                    <div><span style={{fontSize: '0.8rem', color: 'rgb(117, 117, 117)'}}>IVA: </span><TextField source="iva" style={{fontSize: '1.0rem'}}/></div>
                                    <div><span style={{fontSize: '0.8rem', color: 'rgb(117, 117, 117)'}}>Nº GLN: </span><TextField source="gln" style={{fontSize: '1.0rem'}}/></div>
                                </Box>
                            </Box>
                            <Box style={{width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
                                <Box className={classes.DirectionCard}>
                                    <Typography style={{fontSize: '1.5rem', marginBottom: '20px'}}>
                                        <RoomOutlinedIcon style={{marginBottom: '-3px'}}/>&nbsp;Dirección de la Sociedad
                                    </Typography>
                                    <Box style={{marginTop: '10px'}}>
                                        <Typography style={{fontSize: '1.0rem'}}>
                                            {data.address}
                                        </Typography>
                                        <Typography style={{fontSize: '1.0rem'}}>
                                            <StateName id={data.state} style={{fontSize: '1.0rem'}}/>, {data.location}
                                        </Typography>
                                        <Typography>
                                            <CountryName id={data.country} style={{fontSize: '1.0rem'}}/>
                                        </Typography>
                                    </Box>
                                    <Box style={{marginTop: '20px', marginLeft: '-7px'}}>
                                        <div className={classes.MapsButton} onClick={() => redirect(`/pointOfSale?displayedFilters={}&filter={"company_id"%3A"${data.id}"}`)}>
                                            <Button>Ver Tiendas de la Sociedad</Button>
                                        </div>
                                    </Box>
                                </Box>
                                <Box className={classes.ContactBox}>
                                    
                                    {data.contact && data.contact.map(Contact => (
                                        <div className={classes.Contact}>
                                            <Box>
                                                <Typography style={{fontSize: '1.5rem'}}>
                                                    <PermContactCalendarOutlinedIcon style={{marginBottom: '-3px'}}/>&nbsp;{Contact.contactName}
                                                </Typography>
                                                <Typography style={{fontSize: '1.0rem', display: 'flex', width: '100%'}}>
                                                    <Box><a href={`mailto:${Contact.email}`}><MailOutlineRoundedIcon id="mail"/>&nbsp;{Contact.email}</a></Box>
                                                </Typography>
                                                <Typography style={{fontSize: '1.0rem'}}>
                                                    <LocalPhoneRoundedIcon id="phone"/>{Contact.phone}
                                                </Typography>
                                            </Box>
                                        </div>
                                    ))}
                                </Box>
                            </Box>
                        </Box>
                    }
                </Box>
            </Show>
        </Box>
    )
}; export default PointsView;